export default {"src":"/_next/static/media/step3g.44a8d59e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};